import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';

import * as yup from 'yup';

export interface HelpdeskTaskTemplateInterface {
  id: number;
  name: string;
}

export const HelpdeskTaskTemplateDto = SerdeDtoClass.create<HelpdeskTaskTemplateInterface>(
  HelpdeskDtoKeyEnum.HELPDESK_TASK_TEMPLATE_DTO,
  {
    id: {
      label: 'Номер',
      serializer: yup.number(),
    },
    name: {
      label: 'Имя',
      serializer: yup.string(),
    },
  },
);